export enum MutationKeys {
  cart = 'cart',
  cartUpdate = 'cartUpdate',
  cartRemove = 'cartRemove',
  registerUser = 'registerUser',
  checkout = 'checkout',
}
export type MutationKeysType = keyof typeof MutationKeys;
